import { parseISO } from 'date-fns'
import DayCount from 'app/components/DayCount'
import DodoneGenericStats from 'app/dodones/generic/Stats'

const Percentage = ({ dodone }) => {
  const totalCount = dodone.children.length

  const closedCount = useMemo(() => {
    return dodone.children.filter((child) => {
      return child.isClosed
    }).length
  })

  const percentage = totalCount === 0 ? 0 : (closedCount / totalCount) * 100
  const contents = closedCount > 0 ? `${closedCount} of ${totalCount}` : ''

  return (
    <div className="percentage-bar mb-d">
      <div className="percentage-bar-fill" style={{ width: `${percentage}%` }}>
        {contents}
      </div>
    </div>
  )
}

const NoSmoking = () => {
  const dateString = '2026-08-03T10:00:00Z'
  const parsedDate = parseISO(dateString)

  return <DayCount startedAt={parsedDate} after="sem cigarro" />
}

const NoGaming = () => {
  const dateString = '2026-08-03T10:00:00Z'
  const parsedDate = parseISO(dateString)

  return <DayCount startedAt={parsedDate} after="sem joguinho" />
}

const Freedom = () => {
  const dateString = '2026-08-03T10:00:00Z'
  const parsedDate = parseISO(dateString)

  return <DayCount startedAt={parsedDate} after="Sem JPCA" />
}

const Dashboard = ({ dodone }) => {
  return (
    <div className="flex-1 fcol">
      <Percentage dodone={dodone} />
      <div className="mb-d">
        <Freedom />
      </div>
      <div className="mb-d">
        <DodoneGenericStats dodone={dodone} />
      </div>
    </div>
  )
}

export default Dashboard
